import layout from '../../../styles/layout.module.css'
import Head from 'next/head'
import Container from 'react-bootstrap/Container'
import { useTranslation } from 'next-i18next'
import { withNamespace } from '../../../src/util/src/i18next'
import guides from '../../../styles/guides.module.css'
import { getFollowUrl } from '../../../src/Social/models/SocialChannel/getFollowUrl'
import { z } from 'zod'
import { Game } from '../../../src/PlayToEarn/models/Game'
import { byId, IdSchema } from '../../../src/Generic/models/Id'
import { GetStaticProps } from 'src/var/next/next'
import { allGames } from '../../../src/PlayToEarn/data/allGames'
import { getTranslations } from '../../../src/var/next/next-i18next'

export default function PlayToEarnGame(props: Props) {
  const { game } = props

  const { t } = useTranslation(translationNamespaces)
  const tc = withNamespace(t, 'common')
  const title = game.name
  const description = game.description

  return (
    <Container className={layout.main}>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
      </Head>
      <h1 className={guides.instructionSubheader}>{title}</h1>
      <hr />
      {/* TODO: use next/image (requires static sizes for images) */}
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <p><img height={300} src={game.image} alt={game.name} /></p>
      <p>{description}</p>
      <ul>
        {game.channels.map(channel => <li key={getFollowUrl(channel)}><a href={getFollowUrl(channel)}>{channel.type.network.name}</a>: {channel.subscriberCount}</li>)}
      </ul>
    </Container>
  )
}

interface Props {
  [key: string]: unknown
  game: Game
}

const ParamsSchema = z.object({
  id: IdSchema,
})

type Params = z.infer<typeof ParamsSchema>

export const getStaticProps: GetStaticProps<Props, Params> = async (context) => {
  const { locale, params } = context
  if (!params) return { notFound: true }
  const { id } = params
  const game = allGames.find(byId(id))
  if (!game) return { notFound: true }
  const $game = JSON.parse(JSON.stringify(game)) // workaround for date serialization
  const translations = await getTranslations(context, translationNamespaces)
  return {
    props: {
      ...translations,
      game: $game,
    },
  }
}

const translationNamespaces = ['play-to-earn-games', 'play-to-earn', 'common']

export async function getStaticPaths() {
  const paths = allGames.map(game => ({ params: { id: game.id } }))
  return {
    paths,
    fallback: false,
  }
}
